import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const baseUrl = (typeof config !== 'undefined' && config.url) ? config.url : ''

export default new Vuex.Store({
  state: {
    loading: false,
    url: {
      getList:  baseUrl + '/httpbusiness/jxc/getList.ashx',
      addData:  baseUrl + '/httpBusiness/AddData.ashx',
      upload:   baseUrl + '/httpBusiness/AddData.ashx',
      delete:   baseUrl + '/httpBusiness/DeleteData.ashx',
      download: baseUrl + '/httpbusiness/download',
    },
    pageData: {
      tableData: [],
      pNum: 1,
      pSize: 10,
      total: 0,
    },
    pageData2: {
      tableData: [],
      pNum: 1,
      pSize: 10,
      total: 0,
    },
  },
  mutations: {},
  actions: {},
})



// WEBPACK FOOTER //
// ./src/store/index.js